import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=24eb8c66&scoped=true&"
import script from "./UserName.vue?vue&type=script&lang=js&"
export * from "./UserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb8c66",
  null
  
)

export default component.exports